import { Component, input, OnInit } from '@angular/core';
import { AssessmentInfoComponent } from '../assessment-info/assessment-info.component';
import { AssessmentRowComponent } from '../../assessments-tab/assessment-row/assessment-row.component';
import { EmrListComponent } from "../../../../shared/emr-list/emr-list.component";
import { MusculoskeletalAssessment } from 'src/app/calvin-emr-shared/models/assessments/musculoskeletal.model';
import { Patient } from 'src/app/calvin-emr-shared/models/patient.model';

@Component({
  selector: 'app-musculoskeletal-info',
  templateUrl: './musculoskeletal-info.component.html',
  styleUrls: ['./musculoskeletal-info.component.scss'],
  standalone: true,
  imports: [AssessmentRowComponent, EmrListComponent],
})
export class MusculoskeletalInfoComponent
  extends AssessmentInfoComponent<MusculoskeletalAssessment>
  implements OnInit {

  patient = input.required<Patient>();

  ngOnInit(): void { }

  get hasFallHistory() {
    return this.data().fallHistory ? 'Yes - one fall within 6 months before admission' : 'No';
  }

  get fallRiskCategory(): string {
    if (this.data().fallScore < 6) {
      return 'Low';
    } else if (this.data().fallScore >= 6 && this.data().fallScore <= 13) {
      return 'Medium';
    } else {
      return 'High';
    }
  }

  get HDfallRisk(): string {
    if (this.data().HDtotalScore < 12) {
      return 'Not at Risk';
    } else {
      return 'At Risk';
    }
  }
}
